import React, { CSSProperties } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faFilePen } from '@fortawesome/free-solid-svg-icons';

interface PackingSlipPlusIconProps {
  onClick?: () => void;
  className?: string;
  style?: React.CSSProperties;
}

const iconStyle: CSSProperties = {
  position: 'relative',
  paddingLeft: '5px',
};

const iconPlusStyle: CSSProperties = {
  position: 'absolute',
  top: '8px',
  left: '-5px',
  fontSize: '10px',
};

const PackingSlipPlusIcon: React.FC<PackingSlipPlusIconProps> = ({
  onClick,
  className = '',
  style = {},
}) => (
  <div
    style={{ ...iconStyle, ...style }}
    className={`${className}`}
    onClick={onClick}
  >
    <FontAwesomeIcon icon={faFilePen} />
    <FontAwesomeIcon icon={faPlus} style={iconPlusStyle} />
  </div>
);

export default PackingSlipPlusIcon;
